module.exports = __webpack_public_path__ + "img/LNB_tour.22a4d777.svg";